var isNull = require('./null')
var isUndefined = require('./undefined')

/**
 * @desc Checks if `value` is `null` or `undefined`.
 * @alias isNil
 * @category Lang
 *
 * @param  {*} x value
 * @return {boolean} isNullOrUndefined
 *
 * @since 4.0.0-alpha.1
 * @memberOf is
 * @func isNullOrUndefined
 *
 * @see is/null
 * @see is/undefined
 * @see https://github.com/infernojs/inferno/blob/master/packages/inferno-shared/src/index.ts#L23
 *
 * @example
 *
 *  isNullOrUndefined(null)
 *  //=> true
 *  isNullOrUndefined(undefined)
 *  //=> true
 *  isNullOrUndefined(void 0)
 *  //=> true
 *
 *  isNullOrUndefined(NaN)
 *  //=> false
 *  isNullOrUndefined({})
 *  //=> false
 *  isNullOrUndefined('')
 *  //=> false
 *  isNullOrUndefined(1)
 *  //=> false
 *  isNullOrUndefined(false)
 *  //=> false
 *
 */
module.exports = function isNullOrUndef(x) {
  return isUndefined(x) || isNull(x)
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibnVsbE9yVW5kZWZpbmVkLmpzIiwic291cmNlcyI6WyJudWxsT3JVbmRlZmluZWQuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgaXNOdWxsID0gcmVxdWlyZSgnLi9udWxsJylcbmNvbnN0IGlzVW5kZWZpbmVkID0gcmVxdWlyZSgnLi91bmRlZmluZWQnKVxuXG4vKipcbiAqIEBkZXNjIENoZWNrcyBpZiBgdmFsdWVgIGlzIGBudWxsYCBvciBgdW5kZWZpbmVkYC5cbiAqIEBhbGlhcyBpc05pbFxuICogQGNhdGVnb3J5IExhbmdcbiAqXG4gKiBAcGFyYW0gIHsqfSB4IHZhbHVlXG4gKiBAcmV0dXJuIHtib29sZWFufSBpc051bGxPclVuZGVmaW5lZFxuICpcbiAqIEBzaW5jZSA0LjAuMC1hbHBoYS4xXG4gKiBAbWVtYmVyT2YgaXNcbiAqIEBmdW5jIGlzTnVsbE9yVW5kZWZpbmVkXG4gKlxuICogQHNlZSBpcy9udWxsXG4gKiBAc2VlIGlzL3VuZGVmaW5lZFxuICogQHNlZSBodHRwczovL2dpdGh1Yi5jb20vaW5mZXJub2pzL2luZmVybm8vYmxvYi9tYXN0ZXIvcGFja2FnZXMvaW5mZXJuby1zaGFyZWQvc3JjL2luZGV4LnRzI0wyM1xuICpcbiAqIEBleGFtcGxlXG4gKlxuICogIGlzTnVsbE9yVW5kZWZpbmVkKG51bGwpXG4gKiAgLy89PiB0cnVlXG4gKiAgaXNOdWxsT3JVbmRlZmluZWQodW5kZWZpbmVkKVxuICogIC8vPT4gdHJ1ZVxuICogIGlzTnVsbE9yVW5kZWZpbmVkKHZvaWQgMClcbiAqICAvLz0+IHRydWVcbiAqXG4gKiAgaXNOdWxsT3JVbmRlZmluZWQoTmFOKVxuICogIC8vPT4gZmFsc2VcbiAqICBpc051bGxPclVuZGVmaW5lZCh7fSlcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNOdWxsT3JVbmRlZmluZWQoJycpXG4gKiAgLy89PiBmYWxzZVxuICogIGlzTnVsbE9yVW5kZWZpbmVkKDEpXG4gKiAgLy89PiBmYWxzZVxuICogIGlzTnVsbE9yVW5kZWZpbmVkKGZhbHNlKVxuICogIC8vPT4gZmFsc2VcbiAqXG4gKi9cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24gaXNOdWxsT3JVbmRlZih4KSB7XG4gIHJldHVybiBpc1VuZGVmaW5lZCh4KSB8fCBpc051bGwoeClcbn1cbiJdLCJuYW1lcyI6WyJjb25zdCJdLCJtYXBwaW5ncyI6IkFBQUFBLEdBQUssQ0FBQyxNQUFNLEdBQUcsT0FBTyxDQUFDLFFBQVEsQ0FBQztBQUNoQ0EsR0FBSyxDQUFDLFdBQVcsR0FBRyxPQUFPLENBQUMsYUFBYSxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUF1QzFDLE1BQU0sQ0FBQyxPQUFPLEdBQUcsU0FBUyxhQUFhLENBQUMsQ0FBQyxFQUFFO0VBQ3pDLE9BQU8sV0FBVyxDQUFDLENBQUMsQ0FBQyxJQUFJLE1BQU0sQ0FBQyxDQUFDLENBQUM7Q0FDbkM7In0=